import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Divider, Button, Space } from 'antd';
import {
  DoubleLeftOutlined,
  DoubleRightOutlined
} from '@ant-design/icons';
import styles from './index.module.scss';
import { getDocumentMenu } from 'menu-items/document_menu';
import { useNavigate } from 'react-router';
const Method = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState({});

  const location = useLocation(); // 使用 useLocation 获取当前位置信息

  useEffect(() => {
    const pathPart = location.pathname + location.search; // 拼接路径和查询参数
    async function getResult(pathPart) {
      const result = await findPrevAndNextByUrl(pathPart);
      setPage(result);
    }
    getResult(pathPart);

  }, [window.location.href]);


  async function findPrevAndNextByUrl(targetUrl) {
    const data = await getDocumentMenu();
    let prev = null;
    let next = null;
    let targetFound = false;

    function recursiveTraversal(arr) {
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if (element.type === 'item') {
          if (element.url === targetUrl) {
            targetFound = true;
            prev = arr[i-1];
          } else if (targetFound && next === null) {
            next = element;
            return; // 找到目标元素以及其前后元素后，结束遍历
          }
        } else if (element.children && element.children.length > 0) {
          recursiveTraversal(element.children);
        }
      }
    }

    recursiveTraversal(data.children);
    return { prev, next };
  }



  return (
    <>
      <Divider style={{
        borderColor: '#0000221F',
      }} />
      <Space>
        {page.prev && <Button onClick={() => navigate(page.prev.url)} icon={<DoubleLeftOutlined className={styles.arrowIcon} />}>{page.prev.title}</Button>}
        {page.next && <Button onClick={() => navigate(page.next.url) } icon={<DoubleRightOutlined className={styles.arrowIcon} />} iconPosition={'end'}>{page.next.title}</Button>}
      </Space>
    </>
  );
};

export default Method;